import './game.css';
import React, { useState, useEffect } from 'react';
import Chat from '../chat/chat';
import loading from'../../images/load.gif'

function Game({goNext,arr,answers, ifIncorrect, endPlay, goForward, setFailedGame, hints, askCount, setAskCount, mistakes, setMistakes, ifGameFailed, galleryWork, setGalleryWork}) {
  const [img, setImg] = useState(0);
  const [incorrectAnswers, setncorrectAnswers] = useState(0);
  const [done, setDone] = useState(false);
  const [white, setWhite] = useState(1);
  const [load, setLoad] = useState(true);
  const [index, setIndex] = useState(14);
  const [ask, setAsk] = useState(false);
  const [askAb, setAskAb] = useState(true);

  useEffect(async () => {
    const proms = await arr.map((img) => {
      return new Promise(function (resolve, reject){
        let image = new Image();
        image.src = img.img;
        image.onload = () => {
        window[img.img] = image;
        resolve();
    };
      });
    });
    		await Promise.all(proms);
        setLoad(false);
        changeWhite(true);
},[]);

useEffect(() => {
if(askCount>2){
  setAskAb(false);
}
},[askCount]);


  function changeWhite(toLow){
    return new Promise((resolve, reject) => {
    if(toLow){
      var op=1;
      change(toLow);
    }else{
      var op=0;
      change();
    }
    function change(toLow){
    if(toLow){
      if(op>0){
        op-=0.03;
      setWhite(op);
      setTimeout(ChangetoLow, 10);
    }else{
      setIndex(0);
      resolve();
      return;
    }
  }else{
    if(op<1){
      op+=0.03;
    setWhite(op);
    setTimeout(change, 10);
  }else{
    resolve();
    return;
  }
  }

  function ChangetoLow(){
     change(true);
  }
  }
  });
  }
  function retry(){
    setncorrectAnswers(0);
    setDone(false);
    setImg(0);
    changeWhite(true);
  }

  async function goBack(){
    setAsk(false);
    await changeWhite(true);
  }

  async function asking(){
    if(askCount<3){
      localStorage.setItem('askCount', askCount+1);
      setAskCount(askCount+1);
      setIndex(14);
  await changeWhite();
  setAsk(true);
  }
  }

async function answer(e){
  if(arr[img].img){
    let newGallery = new Map(galleryWork)
    if(galleryWork.has(arr[img].img)){
      if(galleryWork.get(arr[img].img) !== "1"){
      newGallery.set(arr[img].img, '1');
      localStorage.setItem('galleryWork', JSON.stringify(Array.from(newGallery.entries())));
      setGalleryWork(newGallery);
    }
    }
  }
if(e.target.innerHTML.toLowerCase() !== arr[img].answer){
setncorrectAnswers((prev) => prev+1);
}
if(img<arr.length-1){
setImg((prev) => prev+1);
}else{
  setIndex(14);
if(incorrectAnswers === 0 || goForward){
  if(incorrectAnswers>0 && goForward && !hints){
      localStorage.setItem('failedGame', 1);
      setFailedGame(1);
  }
  if(ifGameFailed){
    if((mistakes+incorrectAnswers)>3){
      localStorage.setItem('failedGame', 1);
      setFailedGame(1);
    }
  }
  if(incorrectAnswers>0 && hints){
    localStorage.setItem('mistakes', mistakes+incorrectAnswers);
    setMistakes(mistakes+incorrectAnswers);
  }
  await changeWhite();
  goNext();
}else{
  await changeWhite();
  setDone(true);
}
}
  }

  if(incorrectAnswers>0 && done && ifIncorrect && !goForward){
    return(
      <Chat from={ifIncorrect.from} mess={ifIncorrect.messages} goNext={retry} goMenu={endPlay}/>
    );
  }

  if(ask){
    return(
      <Chat from={hints.from} mess={[...hints.messages,{img:arr[img].img, height:"350px", from:'messageFromMe'},{text:"Where does it go?",from:'messageFromMe'},{text:"Hmmm",from:'messageFromHer'},{text:"Obviously, it's "+arr[img].answer,from:'messageFromHer', endOfChat: {text:'GO BACK >'}}]} goNext={goBack} goMenu={endPlay}/>
    );
  }

  if(load){
  return (
    <div className='wr1'><img src={loading} style={{width:"10vw"}}/></div>
  );
}
  return (
<div className='wr'>
<div className='clickWrap' id='wrap' style={{opacity:white, zIndex:index}}></div>
<img src={arr[img].img} id='img'/>
{!done && <div className='choises'>
{answers.map((item, index) =>{
  return <div key={index} onClick={answer}>{item}</div>
})
}
</div>
}
{hints && <h1 id={askAb? "ask" : "ask1"} onClick={asking}>?</h1>}
{done && <div className='mis' onClick={retry}>Ur mistakes number is {incorrectAnswers} <br/> CLICK HERE TO RETRY </div>}
</div>
  );
}

export default Game;
